import { render, staticRenderFns } from "./Ftr.vue?vue&type=template&id=cde61656&scoped=true&"
import script from "./Ftr.vue?vue&type=script&lang=js&"
export * from "./Ftr.vue?vue&type=script&lang=js&"
import style0 from "./Ftr.vue?vue&type=style&index=0&id=cde61656&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cde61656",
  null
  
)

export default component.exports